import { useAuth } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";
import styles from "./TopBar.module.css";

const PAGE_TITLES = {
  "/dashboard":   "Dashboard",
  "/clients":     "Clients",
  "/finance":     "Finance & Reports",
  "/commissions": "Commissions",
  "/jobs":        "Job Listings",
  "/employees":   "Employees",
};

export default function TopBar({ onMenuClick }) {
  const { signOut, profile } = useAuth();
  const { pathname } = useLocation();

  let title = "Royal Horizon";
  if (pathname === "/clients/new") {
    title = "Add Client";
  } else if (pathname.startsWith("/clients/") && pathname.endsWith("/edit")) {
    title = "Edit Client";
  } else {
    const base = "/" + pathname.split("/")[1];
    title = PAGE_TITLES[base] ?? "Royal Horizon";
  }

  return (
    <header className={styles.bar}>
      <div className={styles.left}>
        {/* Hamburger — mobile only */}
        <button
          className={styles.menuBtn}
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <span /><span /><span />
        </button>
        <div className={styles.title}>{title}</div>
      </div>

      <div className={styles.right}>
        <span className={styles.greeting}>
          {profile?.full_name?.split(" ")[0]}
        </span>
        <button className={styles.signOut} onClick={signOut}>
          Sign Out
        </button>
      </div>
    </header>
  );
}